export const stripeKeys = {
    live: "pk_live_51IefWZEfWOjwetWPU7hpUsj3lIDQ7ziEQsRz62QIMnMhwK3WIgw0i8MWsK1kNDIzm5wSZikS7NYXeFgmfazOcaks0070GwcWzm",
    test: "pk_test_51IefWZEfWOjwetWPxnBDPVmpHQHFnLVX9n8wWAind4TcD40lhE0FAl0EBahtcNkPk9XWkLnENMSoliSFCbub9T6Y00AQ7RZaWc",
    secret: "sk_test_51IefWZEfWOjwetWPZ7pERPl09kLzhMlGhx7YUeDw8MYCLcmHUqsW6OvmBO7uHAjZDebzVTWGlXCblzlPqFOj7hJ600SD9pFcM5"
}


// WEBPACK FOOTER //
// /src/assets/data/stripe/keys.ts